import { useApiQuery } from "app/modules/api-client";
import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import type { IIndustryDataAvailabilityState } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";
import { INDUSTRY_ENDPOINT_MIN_DATE } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";

import type { IFormatShare } from "../../hooks/useFormatBreakdown";
import { useIndustryAvailabilityParams } from "../useIndustryAvailabilityParams";

interface IIndustryFormatBreakdownData {
    spendShare: IFormatShare;
    impressionsShare: IFormatShare;
    visitsShare: IFormatShare;
    startDate: string;
}

interface IUseIndustryFormatBreakdownResult {
    data?: IIndustryFormatBreakdownData;
    isLoading: boolean;
    isError: boolean;
    availability: IIndustryDataAvailabilityState;
}

export const useIndustryFormatBreakdown = (category: IFlattenedCategory): IUseIndustryFormatBreakdownResult => {
    const { params, availability } = useIndustryAvailabilityParams(
        category,
        INDUSTRY_ENDPOINT_MIN_DATE.adintelligenceIndustryFormatList,
    );

    const { data, isLoading, isFetching, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adintelligenceIndustryFormatList",
            options: {
                enabled: !availability.isFullyUnavailable,
                select: (response) => ({
                    spendShare: response?.spendShare,
                    impressionsShare: response?.impressionsShare,
                    visitsShare: response?.visitsShare,
                    startDate: response?.startDate,
                }),
            },
        },
        params,
    );

    return {
        data,
        isLoading: isLoading || isFetching,
        isError,
        availability,
    };
};
